import { LoginRoutes } from '@/repository/auth';
const { Login, Logout } = LoginRoutes;

export default {
	namespaced: true,
	actions: {
		async store({ commit }, data) {
			try {
				return await Login(data)
			}
			catch (error) {
				console.error('Could not be logged in', error);
				throw error;
			}
		},
		async destroy({ commit }) {
			try {
				let res = await Logout();
				if (res.status === 302 || res.status === 401) {
					this.commit('auth/user/SET_CURRENT_USER', null)
					return true;
				}
				return false;
			}
			catch (error) {
				console.error('User could not be logged out.', error);
				throw error;
			}
		}
	}
}